import { render } from "./BoatFee.vue?vue&type=template&id=51dea3c4&scoped=true"
import script from "./BoatFee.vue?vue&type=script&lang=js"
export * from "./BoatFee.vue?vue&type=script&lang=js"

import "./BoatFee.vue?vue&type=style&index=0&id=51dea3c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51dea3c4"

export default script